import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AuthService} from "./auth/auth-service";
import {environment} from "../../environments/environment";
import { from } from "rxjs";
import {Store} from "./store.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, public store: Store) {}

  private async loggedIn(req: HttpRequest<any>, next: HttpHandler) {
    const loggedIn = await this.authService.isLoggedIn();
    if (loggedIn === true) {
      const token = await this.authService.getToken();
      const authReq = req.clone({
        setHeaders: {
          "Content-Type": "application/json",
          "Content-Language": this.store.state.common.lang,
          Authorization: (token ? "Bearer " + token : ""),
        },
      });
      // Important: Note the .toPromise()
      return next.handle(authReq).toPromise();
    }
    // Important: Note the .toPromise()
    return next.handle(req).toPromise();
  }

  private static shouldBypass(req: HttpRequest<any>): boolean {
    // Define the pattern for endpoints that should bypass this interceptor
    if (req.url.startsWith(environment.BASE_URL + "translation/cached")) { return true; }
    if (!Boolean(environment.KEYCLOAK_ACTIVE) && req.url.startsWith(environment.CAS_URL)) { return true; }
    return false;
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (AuthInterceptor.shouldBypass(req)) {
      return next.handle(req);
    }
    return from(this.loggedIn(req, next));
  }
}
